// Generated by scripts/styles/generate-public-styles.mjs. Do not edit.
export const publicStylesHref = "/styles/public.1ce0a5c542f8ecb2.css"
export const articleStylesHref = "/styles/article-critical.83a420c57751c844.css"
export const productStylesHref = "/styles/product-critical.f36263e023da7027.css"
export const compareStylesHref = "/styles/compare-critical.50de167d9f257c8f.css"
export const hubStylesHref = "/styles/hub-critical.4d24a7ac0de62967.css"
export const brandStylesHref = "/styles/brand-critical.d8559921233c3c9c.css"
